(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tyQuizFunnel"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.rp-qz:not([data-bound])').forEach((sec) => {
      sec.setAttribute('data-bound', '1');
      const total = parseInt(sec.dataset.total, 10) || 0;
      const resultsN = parseInt(sec.dataset.results, 10) || 3;
      const panels = {};
      sec.querySelectorAll('[data-panel]').forEach(p => {
        const k = p.dataset.panel === 'q' ? 'q' + p.dataset.index : p.dataset.panel;
        panels[k] = p;
      });
      const bar = sec.querySelector('[data-bar]');
      const live = sec.querySelector('[data-live]');
      const listEl = sec.querySelector('[data-results-list]');
      let pool = [];
      try { pool = JSON.parse(sec.querySelector('[data-pool]').textContent) || []; } catch (e) {}

      let current = 0; // 0 = intro
      const answers = {}; // qIndex -> [tags]

      const show = (key) => {
        Object.values(panels).forEach(p => p.classList.remove('is-active'));
        if (panels[key]) panels[key].classList.add('is-active');
      };
      const progress = () => {
        if (current >= 1 && current <= total) {
          sec.classList.add('is-quizzing');
          bar.style.width = ((current - 1) / total * 100) + '%';
          live.textContent = 'Question ' + current + ' of ' + total;
        } else if (current > total) {
          bar.style.width = '100%';
        }
      };

      const goTo = (n) => {
        current = n;
        if (n === 0) { sec.classList.remove('is-quizzing'); show('intro'); live.textContent = ''; }
        else if (n <= total) { show('q' + n); progress(); }
        progress();
      };

      const scoreAndRender = () => {
        const wanted = {};
        Object.values(answers).forEach(tags => tags.forEach(t => { if (t) wanted[t] = (wanted[t] || 0) + 1; }));
        const scored = pool.map(p => {
          const ptags = (p.tags || '').split(',').map(s => s.trim()).filter(Boolean);
          let score = 0;
          ptags.forEach(t => { if (wanted[t]) score += wanted[t]; });
          return { p, score, ptags };
        });
        scored.sort((a, b) => b.score - a.score);
        let top = scored.filter(s => s.score > 0).slice(0, resultsN);
        if (top.length === 0) top = scored.slice(0, resultsN); // fallback: show any
        const maxScore = top.length ? top[0].score : 0;

        listEl.innerHTML = '';
        if (!top.length) {
          listEl.innerHTML = '<li class="rp-qz__empty">Connect a recommendation collection in the theme editor to show matched products.</li>';
          return;
        }
        top.forEach(({ p, score }) => {
          const li = document.createElement('li');
          li.className = 'rp-qz__rcard';
          const pct = maxScore ? Math.round((score / maxScore) * 100) : 100;
          li.innerHTML =
            '<a class="m" href="' + p.url + '">' + (p.image ? '<img src="' + p.image + '" alt="" loading="lazy">' : '') + '</a>' +
            '<div class="b">' +
              (score > 0 ? '<span class="rp-qz__match">' + Math.max(60, pct) + '% match</span>' : '') +
              '<a class="t" href="' + p.url + '">' + p.title + '</a>' +
              '<span class="p">' + (p.priceFmt || '') + '</span>' +
              '<button type="button" class="a" data-id="' + p.id + '"' + (p.available ? '' : ' disabled') + '>' +
                '<svg viewBox="0 0 24 24" width="15" height="15"><path d="M4 5h2l1.5 11h10l1.5-8H7" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
                (p.available ? 'Add to Cart' : 'Sold Out') + '</button>' +
            '</div>';
          listEl.appendChild(li);
        });

        listEl.querySelectorAll('.a[data-id]').forEach(btn => {
          btn.addEventListener('click', async () => {
            btn.disabled = true;
            const original = btn.textContent;
            try {
              const res = await fetch('/cart/add.js', {
                method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                body: JSON.stringify({ id: btn.dataset.id, quantity: 1 })
              });
              if (!res.ok) throw new Error();
              btn.textContent = 'Added \u2713';
              const cart = await (await fetch('/cart.js')).json();
              document.querySelectorAll('[data-cart-count]').forEach(el => el.textContent = cart.item_count);
            } catch (e) { btn.textContent = 'Try again'; }
            setTimeout(() => { btn.disabled = false; btn.textContent = original; }, 1600);
          });
        });
      };

      sec.querySelector('[data-start]').addEventListener('click', () => goTo(1));

      sec.querySelectorAll('[data-panel="q"]').forEach(panel => {
        const idx = parseInt(panel.dataset.index, 10);
        panel.querySelectorAll('.rp-qz__opt').forEach(opt => {
          opt.addEventListener('click', () => {
            panel.querySelectorAll('.rp-qz__opt').forEach(o => o.classList.remove('is-sel'));
            opt.classList.add('is-sel');
            answers[idx] = (opt.dataset.tags || '').split(',').map(s => s.trim()).filter(Boolean);
            setTimeout(() => {
              if (idx < total) { goTo(idx + 1); }
              else {
                sec.classList.remove('is-quizzing');
                show('loading');
                setTimeout(() => { scoreAndRender(); show('results'); bar.style.width = '100%'; }, 900);
              }
            }, 260);
          });
        });
        const back = panel.querySelector('[data-back]');
        if (back) back.addEventListener('click', () => goTo(idx - 1));
      });

      const restart = sec.querySelector('[data-restart]');
      if (restart) restart.addEventListener('click', () => { for (const k in answers) delete answers[k]; sec.querySelectorAll('.rp-qz__opt').forEach(o => o.classList.remove('is-sel')); goTo(0); });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
